import $ from 'jquery';
import Features from './features';

export default class Slider {
    constructor(){
        const feature = new Features();
        if ($('.stacked-slider').length > 0) {
            $('.stacked-slider').find('> li').first().addClass('active');
            $('.jobs-titles > h2').first().addClass('visible');
            $('.title-content .more').attr('href', $('.stacked-slider').find('> li').first().data('url'));

            $('.jobs-titles > h2').each(function () {
                feature.splitText($(this), 0);
            });
        }

        if ($('.career .slider ul > li').length < 2) {
            $('.career .slider .stacked-next').hide();
        }
    }
    swipeNext(slider) {
        var getCurrent = slider.find('.active').index();
        slider.find('> li').removeClass('active previous');
        if (getCurrent < slider.find('> li').length - 1) {
            slider.find('> li').eq(getCurrent + 1).addClass('active').css({
                'z-index': '2',
                'transform': 'matrix(1, 0, 0, 1, 0, 0)'
            }).find('> div').css({'transform': 'matrix(1, 0, 0, 1, 0, 0)'});
            slider.find('> .active').prev().addClass('previous').css({
                'z-index': '1',
                'transform': 'translate(-101%, 0%) matrix(1, 0, 0, 1, 0, 0)'
            }).find('> div').css({'transform': 'translate(50%, 0%) matrix(1, 0, 0, 1, 0, 0)'});

            setTimeout(function () {
                slider.find('> .active').prev().css({
                    'z-index': '1',
                    'transform': 'translate(101%, 0%) matrix(1, 0, 0, 1, 0, 0)'
                }).find('> div').css({'transform': 'translate(-50%, 0%) matrix(1, 0, 0, 1, 0, 0)'});
            }, 1001);
            this.subSlider(getCurrent + 1);
        } else {
            slider.find('> li').first().addClass('active').css({
                'z-index': '2',
                'transform': 'matrix(1, 0, 0, 1, 0, 0)'
            }).find('> div').css({'transform': 'matrix(1, 0, 0, 1, 0, 0)'});
            slider.find('> li').last().addClass('previous').css({
                'z-index': '1',
                'transform': 'translate(-101%, 0%) matrix(1, 0, 0, 1, 0, 0)'
            }).find('> div').css({'transform': 'translate(50%, 0%) matrix(1, 0, 0, 1, 0, 0)'});

            setTimeout(function () {
                slider.find('li').last().css({
                    'z-index': '1',
                    'transform': 'translate(101%, 0%) matrix(1, 0, 0, 1, 0, 0)'
                }).find('> div').css({'transform': 'translate(-50%, 0%) matrix(1, 0, 0, 1, 0, 0)'});
            }, 1001);
            this.subSlider(0);
        }
        $('.title-content .more').attr('href', $('.stacked-slider').find('> li').eq(getCurrent + 1).data('url'));
    }
    subSlider(index) {
        $('.career .content .title-content .jobs-titles h2').removeClass('visible');
        setTimeout(function () {
            $('.career .content .title-content .jobs-titles h2').eq(index).addClass('visible');
        }, 300);
    }
}